import Table from '@/components/Table/Table.jsx'
import TableChooseProduct from '../_PRODUCT/TableChooseProduct.jsx'

export default function TableChooseBrf(props) {
    const columns = [
        // {
        //     title: '项目编号',
        //     dataIndex: 'prjNo',
        //     component: <Table.ViewText />,
        // },

        {
            title: '需求单代码',
            dataIndex: 'brfNo',
            component: <Table.ViewText />,
        },

        {
            title: '需求单名称',
            dataIndex: 'brfName',
            component: <Table.ViewText />,
        },
    ]

    return (
        <TableChooseProduct
            columns={columns}
            {...props}
        />
    )
}
